import React from "react";
import { Table, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";

interface IShiftCount {
    shiftId: string;
    noOfStudents: number;
    shiftName: string;
}

interface Props {
    shifts: IShiftCount[];
}

export default function ShiftBreakdown({ shifts }: Props) {
    return (
        <div>
            <h6 className="text-muted fw-bold mb-3">
                <FontAwesomeIcon icon={faClock} className="me-2" />
                Shift Breakdown
            </h6>
            <Table size="sm" className="mb-0 bg-white">
                <thead>
                    <tr>
                        <th className="py-2">Shift Name</th>
                        <th className="py-2">Shift ID</th>
                        <th className="py-2 text-end">Students</th>
                    </tr>
                </thead>
                <tbody>
                    {shifts.map((shift) => (
                        <tr key={shift.shiftId}>
                            <td className="py-2">
                                <span className="fw-semibold">{shift.shiftName}</span>
                            </td>
                            <td className="py-2">
                                <code className="text-muted" style={{ fontSize: "0.85rem" }}>
                                    {shift.shiftId}
                                </code>
                            </td>
                            <td className="py-2 text-end">
                                <Badge bg="light" text="dark" className="px-2 py-1">
                                    {shift.noOfStudents.toLocaleString()}
                                </Badge>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}
